import * as React from "react";
import { Icon, Popup } from "semantic-ui-react";

const WarningIndicator: React.FunctionComponent<
    {
        notes: string | null;
        purchaseOrderNumber?: string;
        purchaseOrderRequiredPerCase?: boolean;
    }> = (props) => {
        if (!props.notes?.trim() &&
            (!props.purchaseOrderRequiredPerCase || !!props.purchaseOrderNumber?.trim())) {
            return null;
        }

        return (
            <Popup
                content={
                    <>
                        {!!props.notes?.trim() &&
                            <>
                                <h5>Critical Notes:</h5>{props.notes}
                            </>
                        }
                        {props.purchaseOrderRequiredPerCase && !props.purchaseOrderNumber?.trim() &&
                            <>
                                <h5>Purchase order number for the case has not been provided</h5>
                            </>
                        }
                    </>
                }
                trigger={<Icon className="warning-indicator" color="red" name="warning sign" />}
            />
        );
    };

export { WarningIndicator };
